<template>
  <div class="interaction-container">
    <label>{{ label }}</label>
    <div class="quantity__container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="2"
        stroke="currentColor"
        :class="{ disabled: quantity <= 1 }"
        @click="
          () => {
            if (quantity > 1) {
              handleQuantityClick();
            }
          }
        "
      >
        <path stroke-linejoin="round" d="M19.5 12h-15" />
      </svg>
      <span>
        {{ quantity }}
      </span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="2"
        stroke="currentColor"
        @click="() => handleQuantityClick(true)"
      >
        <path stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  name: "CustomizerQty",
  props: {
    label: {
      type: String,
    },
    quantity: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    handleQuantityClick(increment = false) {
      if (increment) {
        this.$emit("change-qty", { decrement: false });
      } else if (this.quantity > 1) {
        this.$emit("change-qty", { decrement: true });
      }
    },
  },
};
</script>
<style scoped>
.quantity__container {
  padding: 10px;
  border: var(--border-thickness) solid;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.quantity__container svg {
  height: 20px;
  user-select: none;
  transition: 0.4s ease-in-out;
}
.quantity__container svg:not(.disabled) {
  cursor: pointer;
}
.quantity__container svg:not(.disabled):hover {
  opacity: var(--hover-opacity);
}
</style>
